import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import Header from './components/Header';
import About from './containers/About';
import Blogs from './containers/Blogs';
import Contact from './containers/Contact';
import Experience from './containers/Experience';
import Greeting from './containers/Greeting';
import PresentWork from './containers/PresentWork';
import Privacy from './containers/Privacy';
import Projects from './containers/Projects';
import Skills from './containers/Skills';

function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/">
            <Header />
            <Greeting />
            <Skills />
            <Projects />
            <PresentWork />
            <Experience />
            <Blogs />
            <About />
            <Contact />
          </Route>
          <Route exact path="/privacy-policy">
            <Privacy />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
